import { Tag } from "antd";

export const getFulfillmentTypeTag = (fulfillmentType) => {
  if (fulfillmentType === "pickup")
    return <Tag style={{ marginLeft: "15px", fontWeight: "400" }}>Pickup</Tag>;
  return null;
};
